



























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Reservation } from "@/swagger/models";
import { DateTime } from "luxon";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "reservationGraph",
})
export default class ReservationsGraph extends Vue {
    @Prop({ required: true })
    reservations: Partial<Reservation>[];

    @Prop({ default: 7 })
    firstHour: number;

    @Prop({ default: 18 })
    lastHour: number;

    computeReservationStyle(reservation: Partial<Reservation>): Partial<CSSStyleDeclaration> {
        const startTime = DateTime.fromSQL(`${reservation.date} ${reservation.startAt}`, { zone: "utc" }).toLocal();
        const endTime = DateTime.fromSQL(`${reservation.date} ${reservation.endAt}`, { zone: "utc" }).toLocal();

        const startOfDay = startTime.startOf("day").plus({ hours: this.firstHour });
        const endOfDay = startTime.startOf("day").plus({ hours: this.lastHour });

        const dayHours = endOfDay.diff(startOfDay, "hour").hours + 1; // +1 because we also show the last hour
        const durationHours = endTime.diff(startTime, "hour").hours;

        const hoursFromStartOfDay = startTime.diff(startOfDay, "hour").hours;

        return {
            left: (hoursFromStartOfDay / dayHours) * 100 + "%",
            width: (durationHours / dayHours) * 100 + "%",
        };
    }

    formatTime(reservation: Partial<Reservation>): string {
        const startTime = DateTime.fromISO(reservation.startAt, { zone: "utc" }).toLocal();
        const endTime = DateTime.fromISO(reservation.endAt, { zone: "utc" }).toLocal();

        return `${startTime.toLocaleString(DateTime.TIME_24_SIMPLE)} - ${endTime.toLocaleString(
            DateTime.TIME_24_SIMPLE,
        )}`;
    }
}
